import { ReturnTranslatedText } from '@wajeez-web/core/localization';

import { ComponentTypeFormBuilder } from './ComponentTypeFormBuilder';

interface ComponentTypeCreateFormProps {
  onSubmit: (componentTypeId: number) => void;
  onCancel: () => void;
}

export const ComponentTypeCreateForm = ({
  onSubmit,
  onCancel,
}: ComponentTypeCreateFormProps) => {
  return (
    <div>
      <h1 className="text-[24px] font-bold">
        <ReturnTranslatedText
          text={`pageHeader.${'Create New Type'}`}
          origintext="Create New Type"
        />
      </h1>
      <div className="mt-6">
        <ComponentTypeFormBuilder
          type="Create"
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      </div>
    </div>
  );
};
